"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agugliaro": {
    "81861a54": [{
      "hkey": "c1a0e70a",
      "slug": "agugliaro",
      "name": "Agugliaro",
      "primary": true,
      "skipSearch": false
    }],
    "capitello": [{
      "hkey": "c1a0e70a",
      "slug": "agugliaro",
      "name": "Agugliaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2cccc124": [{
      "hkey": "c1a0e70a",
      "slug": "agugliaro",
      "name": "Agugliaro",
      "primary": true,
      "skipSearch": false
    }],
    "finale": [{
      "hkey": "c1a0e70a",
      "slug": "agugliaro",
      "name": "Agugliaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e16169a9": [{
      "hkey": "c1a0e70a",
      "slug": "agugliaro",
      "name": "Agugliaro",
      "primary": true,
      "skipSearch": false
    }],
    "sopra-l-acqua": [{
      "hkey": "c1a0e70a",
      "slug": "agugliaro",
      "name": "Agugliaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;